import { Injectable } from '@angular/core';
import { AppConfig } from '@deltager/organizers/admin/shared/configuration/config.model';
import {
  generateAngularMaterialAccentColor,
  generateAngularMaterialPrimaryColor,
  setCssColorVariable,
} from '../../../sass/util/angularThemeColor';

export function configServiceInitializerFactory(configurationService: ConfigurationService): Function {
  // a lambda is required here, otherwise `this` won't work inside ConfigurationService::load
  return () => configurationService.load();
}

declare var app_config: AppConfig;

@Injectable({
  providedIn: 'root',
})
export class ConfigurationService {
  private configuration: AppConfig = new AppConfig();

  constructor() {}

  public getConfig(): AppConfig {
    return this.configuration;
  }

  get primaryColor(): string {
    return this.configuration.primaryColor;
  }

  get accentColor(): string {
    return this.configuration.accentColor;
  }

  // the return value (Promise) of this method is used as an APP_INITIALIZER,
  // so the application's initialization will not complete until the Promise resolves.
  public load(): Promise<AppConfig> {
    if (typeof app_config !== 'undefined') {
      this.configuration.primaryColor = app_config.primaryColor;
      this.configuration.accentColor = app_config.accentColor;
      this.configuration.headerColor = app_config.headerColor ?? this.configuration.headerColor;
      this.configuration.linkColor = app_config.linkColor ?? this.configuration.linkColor;
      this.configuration.primaryLightColor = app_config.primaryLightColor ?? this.configuration.primaryColor;

      this.configuration.buttonColor = app_config.buttonColor ?? this.configuration.primaryColor;
      this.configuration.buttonHoverColor = app_config.buttonHoverColor ?? this.configuration.primaryColor;
      this.configuration.buttonTextColor = app_config.buttonTextColor ?? this.configuration.buttonTextColor;

      this.configuration.buttonAltColor = app_config.buttonAltColor ?? this.configuration.buttonAltColor;
      this.configuration.buttonAltHoverColor = app_config.buttonAltHoverColor ?? this.configuration.buttonAltHoverColor;
      this.configuration.buttonAltTextColor = app_config.buttonAltTextColor ?? this.configuration.buttonAltTextColor;
    }

    setCssColorVariable('--color-primary', this.configuration.primaryColor);
    setCssColorVariable('--color-accent', this.configuration.accentColor);
    setCssColorVariable('--color-primaryLight', this.configuration.primaryLightColor);
    setCssColorVariable('--color-header', this.configuration.headerColor);
    setCssColorVariable('--color-link', this.configuration.linkColor);

    setCssColorVariable('--color-button', this.configuration.buttonColor);
    setCssColorVariable('--color-button-text', this.configuration.buttonTextColor);
    setCssColorVariable('--color-buttonHover', this.configuration.buttonHoverColor);

    setCssColorVariable('--color-button-alt', this.configuration.buttonAltColor);
    setCssColorVariable('--color-button-text-alt', this.configuration.buttonAltTextColor);
    setCssColorVariable('--color-buttonHover-alt', this.configuration.buttonAltHoverColor);

    generateAngularMaterialPrimaryColor(this.configuration.primaryColor);
    generateAngularMaterialAccentColor(this.configuration.accentColor);

    return Promise.resolve(this.configuration);
  }
}
